<template>
  <main-layout>
    <v-tabs>
      <v-tab v-for="(tab, index) in tabs" :key="index" :to="tab.to">{{ tab.text }}</v-tab>
    </v-tabs>
    <router-view></router-view>
  </main-layout>
</template>

<script>
export default {
  data() {
    return {
      tabs: [
        {
          text: this.$t('asset_wise.main_broadcast'),
          to: { name: 'assetwise-broadcast-main' }
        },
        {
          text: this.$t('asset_wise.executive_broadcast'),
          to: { name: 'assetwise-broadcast-executive' }
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/Broadcast/index.vue